import React, { useEffect, useRef } from 'react';
import {
  Callout as BPCallout,
  CalloutProps as ICalloutProps,
  Intent
} from '@blueprintjs/core';

/**
 * The purpose of this component is to make it easy to bake-in WCAG compliant code
 * by setting the tabIndex prop / attribute to 0, the div element is now focusable
 *
 * When this component mounts, it sets focus to itself so that users can easily
 * access the error and the elements related to the error that follow.
 */

const ErrorCallout: React.FC<ICalloutProps> = (props) => {
  const errorRef = useRef(null); // use ref to manage focus
  useEffect(() => {
    errorRef.current.focus(); // On mount, update focus via a click
  }, []);
  return (
    <div tabIndex={0} ref={errorRef} role="alert" aria-live="polite">
      <BPCallout
        intent={Intent.DANGER} // Intent.DANGER force error visual
        className={props.className ? props.className : 'mb-6 text-small'}
        {...props}
      />
    </div>
  );
};

export default ErrorCallout;
